import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TraineeActionModal from "./TraineeActionModal";
import { postRightworkAPI } from "../requests/utilities/requests";
import { API_post_learning_manager_input_completion } from "../../../constants";

// Manager records/edits a Manager Input value for one trainee, from the Records
// queue. Mirrors the inline ManagerInput flow (same endpoint) so a manager can
// do it from either surface.
function ManagerInputModal({ open, onClose, record, submission, homeCompany, onSaved }) {
  const [value, setValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (!open) return;
    setValue(submission?.input_value || "");
  }, [open, submission]);

  const isEdit = Boolean(submission?.input_value);
  const canSave = value.trim().length > 0 && !saving;

  const handleSave = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      const res = await postRightworkAPI(API_post_learning_manager_input_completion, {
        company_id: homeCompany,
        section_uuid: record.section_uuid,
        manager_input_block_uuid: record.manager_input_block_uuid,
        input_value: value,
        store_team_member_id: submission.store_team_member_id,
      });
      if (res.status === 200) {
        const completion = res.data?.redux?.payload?.manager_input_completion;
        toast.success("Input saved", { autoClose: 2000 });
        if (onSaved) onSaved(submission, value, completion);
        onClose();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.system?.message || "Failed to save input",
        { autoClose: 3000 }
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <TraineeActionModal
      open={open && !!submission}
      onClose={onClose}
      title={`${isEdit ? "Edit input" : "Record input"}: ${submission?.employee_name || ""}`}
      subtitle={record?.name || "Manager Input"}
      primaryLabel="Save input"
      onPrimary={handleSave}
      primaryDisabled={!canSave}
      primaryBusy={saving}
    >
      {record?.description && (
        <p className="text-sm text-slate-600 mb-3">{record.description}</p>
      )}
      <label className="block text-sm font-medium text-slate-800 mb-1.5">
        Input (score, grade, or notes)
      </label>
      <textarea
        rows={4}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="e.g. 11/12, Great Job, or notes for the record"
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-600 resize-none"
      />
    </TraineeActionModal>
  );
}

export default ManagerInputModal;
